(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('olt', {
                    parent: 'app.private',
                    url: '/olt',
                    data: {
                        pageTitle: 'olt.title'
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/olt/olts.html',
                            controller: 'OltController',
                            controllerAs: 'vmOlt'
                        },
                        'search@olt': {
                            templateUrl: 'app/components/olt/olt-search.html',
                            controller: 'OltSearchController',
                            controllerAs: 'vmOltSearch'
                        },
                        'favorites@olt': {
                            templateUrl: 'app/components/favorites/favorites.html',
                            controller: 'FavoritesController',
                            controllerAs: 'vmFavorites'
                        },
                        'list@olt': {
                            templateUrl: 'app/components/olt/olt-list.html',
                            controller: 'OltListController',
                            controllerAs: 'vmOltList'
                        },
                        'detail@olt': {
                            templateUrl: 'app/components/olt/olt-detail.html',
                            controller: 'OltDetailController',
                            controllerAs: 'vmOltDetail'
                        },
                        'history@olt': {
                            templateUrl: 'app/components/olt/olt-history.html',
                            controller: 'OltHistoryController',
                            controllerAs: 'vmOltHistory'
                        },
                        'management@olt': {
                            templateUrl: 'app/components/olt/olt-management.html',
                            controller: 'OltManagementController',
                            controllerAs: 'vmOltManagement'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('olt');
                                $translatePartialLoader.addPart('olt-modals');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();
